<header [class.login-mode]="loginMode">
  <!-- Desktop header -->
  <ng-container *ngIf="!(isHandset$ | async); else handsetHeader">
    <div class="left">
      <img class="logo" [src]="loginMode ? 'assets/images/RevelBase_Home.png' : 'assets/images/RevelBase_Logo.png'" alt="RevelBase" />
    </div>
    <div class="user-info" *ngIf="!loginMode">
      <span *ngIf="userEmail">{{ userEmail }}</span>
      <button (click)="logout()">Logout</button>
    </div>
  </ng-container>

  <!-- Handset header -->
  <ng-template #handsetHeader>
    <div class="left">
      <img class="logo" [src]="loginMode ? 'assets/images/RevelBase_Home.png' : 'assets/images/RevelBase_Logo.png'" alt="RevelBase" />
    </div>
    <div class="user-info" *ngIf="!loginMode">
      <img
        *ngIf="isAuthenticated; else loggedOut"
        class="auth-icon"
        src="assets/images/Logged_In.png"
        alt="Logged In"
        (click)="logout()"
      />
      <ng-template #loggedOut>
        <img
          class="auth-icon"
          src="assets/images/Logged_Out.png"
          alt="Logged Out"
        />
      </ng-template>
    </div>
  </ng-template>
</header>
